import axios from "axios";
import jwtDecode from "jwt-decode";

export * from "./routes.constants";

//export const baseURL = "https://backend.myestate.ng/api/v1";
//export const baseURL = "https://backend.aahera.com.ng/api/v1";
export const baseURL = "https://api.aahera.com.ng/api/v1";

export const SELECTED_ESTATE_STORAGE_KEY = "selectedEstate";
export const ESTATE_OPTIONS = {
  AAHERA: "aahera",
  JUBILEE: "jubilee",
  URBAN_SHELTER: "urbanShelter",
};

const axiosInstance = axios.create({
  baseURL,
  headers: {
    Accept: "application/json, text/plain, */*",
    "Content-Type": "application/json ",
  },
});

const getSelectedEstate = () =>
  localStorage.getItem(SELECTED_ESTATE_STORAGE_KEY) || ESTATE_OPTIONS.AAHERA;

const getUserId = () => {
  const storedUserId = localStorage.getItem("userId");

  if (storedUserId) {
    return storedUserId;
  }

  try {
    const token = localStorage.getItem("11#221#");

    if (!token) {
      return null;
    }

    return jwtDecode(token)?.userId || null;
  } catch (error) {
    return null;
  }
};

const getEstateFlags = () => {
  const selectedEstate = getSelectedEstate();

  return {
    urbanShelter: selectedEstate === ESTATE_OPTIONS.URBAN_SHELTER,
    jubilee: selectedEstate === ESTATE_OPTIONS.JUBILEE,
  };
};

const addEstateFlagsToGetParams = (req) => {
  const flags = getEstateFlags();

  if (req.params instanceof URLSearchParams) {
    req.params.set("urbanShelter", flags.urbanShelter);
    req.params.set("jubilee", flags.jubilee);
    return req;
  }

  req.params = {
    ...(req.params || {}),
    ...flags,
  };

  return req;
};

const addEstateFlagsToPostBody = (req) => {
  const selectedEstate = getSelectedEstate();
  const flags = getEstateFlags();
  const userId = getUserId();

  if (req.data instanceof FormData) {
    if (selectedEstate !== ESTATE_OPTIONS.AAHERA) {
      req.data.set("urbanShelter", flags.urbanShelter);
      req.data.set("jubilee", flags.jubilee);
    }

    if (userId) {
      req.data.set("userId", userId);
    }

    return req;
  }

  req.data = {
    ...(req.data || {}),
    ...(selectedEstate !== ESTATE_OPTIONS.AAHERA ? flags : {}),
    ...(userId ? { userId } : {}),
  };

  return req;
};

const addTokenToRequest = async (req) => {
  const token = localStorage.getItem("11#221#");
  req.headers.Authorization = `Bearer ${token}`;

  if (req.method === "get") {
    return addEstateFlagsToGetParams(req);
  }

  if (req.method === "post") {
    return addEstateFlagsToPostBody(req);
  }

  return req;
};

axiosInstance.interceptors.request.use(addTokenToRequest);

export default axiosInstance;
